import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSessionStore } from '../hooks/useSession';
import toast from 'react-hot-toast';

interface Props {
  sessionId: string;
}

export const SafeWordButton = ({ sessionId }: Props) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const { updateGameState } = useSessionStore();

  const triggerSafeWord = () => {
    updateGameState({ safeWordTriggered: true, pausedAt: new Date().toISOString() });
    toast.success('Safe word triggered - all activity stopped', {
      duration: 5000,
    });
    setShowConfirm(false);
  };

  return (
    <>
      <motion.button
        className="safeword-btn"
        onClick={() => setShowConfirm(true)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        SAFE WORD
      </motion.button>

      <AnimatePresence>
        {showConfirm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(214, 48, 49, 0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              padding: '1rem'
            }}
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              style={{
                background: 'white',
                color: 'var(--danger)',
                borderRadius: 'var(--border-radius)',
                padding: '2rem',
                maxWidth: '400px',
                textAlign: 'center'
              }}
            >
              <h3 style={{ marginBottom: '1rem' }}>Trigger Safe Word?</h3>
              <p style={{ marginBottom: '2rem', color: '#666' }}>
                This will immediately stop all vibrations and end the current game. Your partner will be notified.
              </p>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowConfirm(false)}
                  style={{ flex: 1 }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={triggerSafeWord}
                  style={{ flex: 1 }}
                >
                  Yes, Stop Everything
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
